export const MIN_FINDING_HIGH_SCORE = 3;

export const FINDING_CONDITION_TEMPLATE = {
  OTHER: 'other',
} as const;

export const POST_MENOPAUSAL_FIELD = 'post_menopausal';

export const ENDOMETRIAL_THICKNESS_CONDITION = 'default_question_endometrial_thickness';

export const ENDOMETRIAL_THICKNESS_HIDDEN_VALUES = ['absent', 'partially absent'];

export const UTERUS_APPEARANCE_CONDITION = 'default_question_uterus_appearance';

export const UTERUS_APPEARANCE_CONDITION_NAME = 'uterus_appearance';
